import { Product } from '@core/models/piramide/Product';
import {
  CoolerCpu,
  CoolerFan,
  Cpu,
  Disco,
  Fuente,
  Gabinete,
  Memoria,
  Monitor,
  Mother,
  PlacaVideo,
} from '../model';

export class DataArmado {
  cpus: Cpu[];
  mother: Mother[];
  ccpu: CoolerCpu[];
  memorias: Memoria[];
  gabinetes: Gabinete[];
  fuentes: Fuente[];
  placasVideos: PlacaVideo[];
  monitores: Monitor[];
  discos: Disco[];
  perifericos: Array<Product | CoolerFan>;

  constructor(
    cpus: Cpu[] = [],
    mother: Mother[] = [],
    ccpu: CoolerCpu[] = [],
    memorias: Memoria[] = [],
    gabinetes: Gabinete[] = [],
    fuentes: Fuente[] = [],
    placasVideos: PlacaVideo[] = [],
    monitores: Monitor[] = [],
    discos: Disco[] = [],
    perifericos: Array<Product | CoolerFan> = [],
  ) {
    this.cpus = cpus;
    this.mother = mother;
    this.ccpu = ccpu;
    this.memorias = memorias;
    this.gabinetes = gabinetes;
    this.fuentes = fuentes;
    this.placasVideos = placasVideos;
    this.monitores = monitores;
    this.discos = discos;
    this.perifericos = perifericos;
  }
  vaciarArmado() {
    for (const propiedad of Object.keys(this)) {
      this[propiedad] = [];
    }
  }
  cargarSuperProducto(producto: Product) {
    if (producto instanceof CoolerCpu) {
      this.ccpu.push(producto);
    } else if (producto instanceof Cpu) {
      this.cpus.push(producto);
    } else if (producto instanceof Mother) {
      this.mother.push(producto);
    } else if (producto instanceof Gabinete) {
      this.gabinetes.push(producto);
    } else if (producto instanceof CoolerFan) {
      this.perifericos.push(producto);
    } else if (producto instanceof Disco) {
      this.discos.push(producto);
    } else if (producto instanceof Fuente) {
      this.fuentes.push(producto);
    } else if (producto instanceof Memoria) {
      this.memorias.push(producto);
    } else if (producto instanceof PlacaVideo) {
      this.placasVideos.push(producto);
    } else {
      return [];
    }
  }
}
